export default "__VITE_ASSET__ByQsu0uD__"